import * as React from 'react';

interface Props {
  classes: Record<string, string>;
  appointments?: number;
}

export const ShiftTotal: React.FC<Props> = (props) => {
  const { classes, appointments } = props;

  if (!appointments) {
    return null;
  }

  return <div className={classes.shiftTotal}>shift total: {appointments}</div>;
};
ShiftTotal.displayName = 'AppointmentsTable.ShiftTotal';
